export const lightTheme = {
    backgroundPrimary: "#FCFCFC",
    backgroundTransparent: "rgba(255, 255, 255, 0.75)",
    backgroundSecondary: "#F9F9F9",
    backgroundSpecial: "#F4F4F4",
    backgroundSecondaryTransparent: "rgba(241, 241, 241, 0.7)",

    controlPrimary: "#D5D5D5",
    controlSecondary: "#919498",

    hoverPrimary: "#EBEBEB",
    hoverSecondary: "#FCFCFC",

    borderPrimary: "#DFDFDF",
    borderMono: "#4E4E4E",

    iconColor: "#4E4E4E",

    textColorPrimary: "#4E4E4E",
    textColorSecondary: "#919498",
    textColorSpecial: "#E39685",

    boxShadow: "0 4px 24px -1px",
    boxShadowColor: "rgba(0, 0, 0, 0.25)",

    disabledColor: "rgba(200, 200, 200, 0.25)",

    taskDropTargetColor: "#B9D1FF",
};

export const darkTheme = {
    backgroundPrimary: "#232931",
    backgroundTransparent: "rgba(35, 41, 49, 0.75)",
    backgroundSecondary: "#1D2228",
    backgroundSpecial: "#3D3E42",
    backgroundSecondaryTransparent: "rgba(69, 70, 72, 0.7)",

    controlPrimary: "#767676",
    controlSecondary: "#b6b6b6",

    hoverPrimary: "#515151",
    hoverSecondary: "#232931",

    borderPrimary: "#515151",
    borderMono: "#FFFFFF",

    iconColor: "#FFFFFF",

    textColorPrimary: "#FFFFFF",
    textColorSecondary: "#919498",
    textColorSpecial: "#E39685",

    boxShadow: "0 4px 24px -1px",
    boxShadowColor: "rgba(255, 255, 255, 0.1)",

    disabledColor: "rgba(0, 0, 0, 0.25)",

    taskDropTargetColor: "#5874BC",
};
